import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const ACCENT = '#102E5C';
const PRIMARY = '#00A7E3';

const Settings = () => (
  <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 640, mx: 'auto' }}>
    <Typography variant="h5" sx={{ fontWeight: 700, color: ACCENT, mb: 3 }}>
      Settings
    </Typography>
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Account
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Profile photo and mobile number can be updated on your profile.
      </Typography>
      <Button component={RouterLink} to="/profile" variant="contained" sx={{ textTransform: 'none', bgcolor: PRIMARY, boxShadow: 'none', '&:hover': { bgcolor: '#0094cc', boxShadow: 'none' } }}>
        Open profile
      </Button>
    </Paper>
  </Box>
);

export default Settings;
